import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileCompletionGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    
    // Only apply this guard to tourists
    if (!this.authService.isTourist()) {
      return true;
    }

    return this.authService.currentUser$.pipe(
      take(1),
      map(user => {
        // If no user, allow access but don't redirect
        if (!user) {
          return true;
        }

        // Check if profile is complete
        const isProfileComplete = this.isProfileComplete(user);
        
        if (!isProfileComplete) {
          // If trying to access profile page, allow it
          if (state.url === '/profile') {
            return true;
          }
          
          // Only redirect to profile for specific protected routes
          const protectedRoutes = ['/sadashboard', '/provider-dashboard'];
          const shouldRedirect = protectedRoutes.some(route => state.url.startsWith(route));
          
          if (shouldRedirect) {
            this.router.navigate(['/profile']);
            return false;
          }
        }

        return true;
      })
    );
  }

  /**
   * Check if user profile is complete
   */
  private isProfileComplete(user: any): boolean {
    return !!(
      user.name &&
      user.name.trim() !== '' &&
      user.phone &&
      user.phone.trim() !== '' &&
      user.nationality &&
      user.nationality.trim() !== '' &&
      user.document_id &&
      user.document_id.trim() !== ''
    ); 
  }
}
